<template>
  <tr class="profile-table__row">
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">{{ registration.id }}</div>
    </td>
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">
        {{ registrationName }}
      </div>
    </td>

    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">{{ registrationLang }}</div>
    </td>
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">
        {{ registrationTraining }}
      </div>
    </td>
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item d-flex align-items-center">
        <span
          v-if="formatDate(registration.registrationCreatedAt)"
          class="mr-1 icon icon-calendar"
        />
        <span class="">
          {{ formatDate(registration.registrationCreatedAt, 'DD.MM.YYYY') }}
        </span>
      </div>
    </td>
    <!--<td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item d-flex align-items-center">
        <span v-if="formatDate(registration.sessionStartAt)" class="mr-1 icon icon-calendar" />
        <span class="">
           {{ formatDate(registration.sessionStartAt, "DD.MM.YYYY") }}
        </span>
      </div>
    </td>-->
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">
        <div class="d-flex align-items-center">
          <span
            class="badge badge-icon badge-pill mr-1"
            :class="
              courseTypeSlug == 'e-learning'
                ? 'badge-school'
                : courseTypeSlug == 'virtual-class'
                ? 'badge-combined'
                : courseTypeSlug == 'classroom'
                ? 'badge-class'
                : 'badge-combined'
            "
          />
          <span
            class="badge badge-icon badge-pill"
            :class="
              registrationStatus == 4
                ? 'badge-not-started'
                : registrationStatus == 1
                ? 'badge-icon_in-progress'
                : registrationStatus == 2
                ? 'badge-icon_fail'
                : registrationStatus == 3
                ? 'badge-icon_success'
                : 'badge-not-started'
            "
          ></span>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'RegistrationRow',
  props: ['registration', 'index', 'isLast'],
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapFields(['user']),
    ...mapFields(['registrations.registrations']),
    registrationName() {
      let firstname = this.$lodash.get(
        this.registration,
        'traineeFirstname',
        ''
      )
      let lastname = this.$lodash.get(this.registration, 'traineeLastname', '')
      return lastname + ' ' + firstname
    },
    registrationLang() {
      let tl = this.$lodash.get(
        this.registration,
        'traineePreferredLanguage',
        '--'
      )
      if (tl != null) {
        return tl
      } else return '--'
    },
    registrationStatus() {
      let rs = this.$lodash.get(this.registration, 'resultLessonStatus', false)
      if (rs != null) {
        return rs
      } else return '--'
    },
    registrationTraining() {
      let cn = this.$lodash.get(this.registration, 'courseName', '--')
      if (cn != null) {
        return cn
      } else return '--'
    },
    courseTypeSlug() {
      return this.$lodash.get(this.registration, 'courseTypeSlug', '')
    },
  },
  methods: {
    formatDate(date, format = 'YYYY.MM.DD') {
      if (date && this.$moment(date).isValid()) {
        return this.$moment(date).format(format)
      } else return '--'
    },
  },
}
</script>

<style></style>
